module.exports = __webpack_public_path__ + "img/coupon-item-valid-bg.d96b55eb.png";